<template>
    <div>
        <LoadingVue :isLoading="isLoading" :key="isLoading" />
    
        <div :class="view_class_view.div_container" class="grid grid-cols-1">
            <div class="my-2">
                <label for="input_names">Nombre(s): </label>
                <input type="text" id="input_names" name="input_names" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: beneficiariesModelValidations.names.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!beneficiariesModelValidations.names.$invalid, [view_class_view.class_inputs.default ]: beneficiariesModelValidations.names.$invalid && !beneficiariesModelValidations.names.$error }" class=" w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="beneficiariesModel.names" @blur="beneficiariesModelValidations.names.$validate">
    
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of beneficiariesModelValidations.names.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
    
            <div class="my-2">
                <label for="input_paternal_name">Apellido Paterno: </label>
                <input type="text" id="input_paternal_name" name="input_paternal_name" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: beneficiariesModelValidations.paternal_name.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!beneficiariesModelValidations.paternal_name.$invalid, [view_class_view.class_inputs.default ]: beneficiariesModelValidations.paternal_name.$invalid && !beneficiariesModelValidations.paternal_name.$error }" class=" w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="beneficiariesModel.paternal_name" @blur="beneficiariesModelValidations.paternal_name.$validate">
    
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of beneficiariesModelValidations.paternal_name.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
    
            <div class="my-2">
                <label for="input_maternal_name">Apellido Materno: </label>
                <input type="text" id="input_maternal_name" name="input_maternal_name" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: beneficiariesModelValidations.maternal_name.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!beneficiariesModelValidations.maternal_name.$invalid, [view_class_view.class_inputs.default ]: beneficiariesModelValidations.maternal_name.$invalid && !beneficiariesModelValidations.maternal_name.$error }" class=" w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="beneficiariesModel.maternal_name" @blur="beneficiariesModelValidations.maternal_name.$validate">
    
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of beneficiariesModelValidations.maternal_name.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
    
            <div class="my-2">
                <label for="input_birthdate">Fecha de Nacimiento: </label>
                <date-picker class="block mt-2" simple placeholder="Fecha nacimiento" locale="es" v-model="beneficiariesModel.birthdate" format="DD/MM/YYYY" id="picker_birthdate_beneficiaries" 
                    :localeConfig="{
                          es: {
                            displayFormat: 'DD/MM/YYYY',
                              lang: {
                                year: 'Año',
                                month: 'Mes',
                                day: 'Día',
                                label: '',
                                submit: 'Seleccionar',
                                cancel: 'Cancelar',
                                now: 'Hoy',
                                nextMonth: 'Siguiente',
                                prevMonth: 'Anterior',
                              },
                            }
                        }" />
    
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of beneficiariesModelValidations.birthdate.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
    
            <div class="my-2">
                <label for="input_percentage">Porcentaje: </label>
                <input type="number" id="input_percentage" name="input_percentage" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: beneficiariesModelValidations.percentage.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!beneficiariesModelValidations.percentage.$invalid, [view_class_view.class_inputs.default ]: beneficiariesModelValidations.percentage.$invalid && !beneficiariesModelValidations.percentage.$error }" class="uppercase w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="beneficiariesModel.percentage" @blur="beneficiariesModelValidations.percentage.$validate">
    
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of beneficiariesModelValidations.percentage.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
    
            <div class="my-2">
                <label for="input_relationship">Parentesco: </label>
                <select type="text" id="input_relationship" name="input_relationship" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: beneficiariesModelValidations.relationship.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!beneficiariesModelValidations.relationship.$invalid, [view_class_view.class_inputs.default ]: beneficiariesModelValidations.relationship.$invalid && !beneficiariesModelValidations.relationship.$error }" class="uppercase w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="beneficiariesModel.relationship" @blur="beneficiariesModelValidations.relationship.$validate">
                    <option v-for="(relationship, index) of relationship_list" :key="index" :value="relationship.value">{{ relationship.text }}</option>
                </select>
                
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of beneficiariesModelValidations.relationship.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
    
        </div>
    
        <div>
            <div>
                <div class="mt-10 w-full px-5 sm:text-center mb-10">
                    <button id="button_add_beneficiary" :class="view_class_view.class_inputs.submit" class="px-5 py-2 w-full text-white text-center" @click="addBeneficiary()"> Añadir </button>
                </div>
                <div class="sm:w-3/4 xl:full mt-2 ml-6">
                    <div class="flex justify-between font-bold">
                        <h5 class="text-xl">Beneficiarios</h5>
                        <h6>%</h6>
                    </div>
                    <div class="card__body">
                        <div v-for="(benefiary, i) in beneficiariesList" :key="i" class="w-full row flex justify-between mb-4">
                            <div class="w-full">
                                <div class="flex">
                                    <h6>{{ benefiary.names }} {{ benefiary.paternal_name }} {{ benefiary.maternal_name }}</h6>
                                </div>
                                <p class="text-sm capitalize">{{ benefiary.relationship }} | {{ getAgeByBirthDate(benefiary.birthdate) }} <span>años</span></p>
                            </div>
                            <div class="font-medium">{{ benefiary.percentage }}% <div><button class="text-xs text-red-400" @click="removeBeneficiary(i)">Eliminar</button></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    </div>
</template>
    
<script>
    import {
        ref
    } from 'vue';
    import useVuelidate from '@vuelidate/core';
    import LoadingVue from '../VueLoading.vue';
    import swal from 'sweetalert2';
    
    import {
        helpers,
        requiredIf
    } from "@vuelidate/validators";
    
    export default {
        name: 'IssuanceBeneficiaries',
        props: {
            relationship_list: {
                type: Array,
                required: true,
                default(){
                    return [
                        {value: "ESPOSO", text:"ESPOSO"},
                        {value: "ESPOSA", text:"ESPOSA"},
                        {value: "PADRE", text:"PADRE"},
                        {value: "MADRE", text:"MADRE"},
                        {value: "HIJO", text:"HIJO"},
                        {value: "HIJA", text:"HIJA"},
                        {value: "HERMANO", text:"HERMANO"},
                        {value: "HERMANA", text:"HERMANA"},
                    ];
                }
            },
            payment_methods: {
                type: Array,
                required: true,
                default () {
                    return [{
                        value: 'tarjeta de crédito',
                        text: 'Tarjeta de crédito'
                    }, {
                        value: 'tarjeta de débito',
                        text: 'tarjeta de débito'
                    }, {
                        value: 'transferencia bancaria',
                        text: 'transferencia bancaria'
                    }, {
                        value: 'descuento por nomina',
                        text: 'Descuento por nomina'
                    }];
                }
            },
            payment_frequencies: {
                type: Array,
                required: true,
                default () {
                    return [{
                        value: 'mensual',
                        text: 'Mensual'
                    }];
                }
            },
            view_class_view: {
                type: Object,
                required: true,
                default () {
                    return {
                        class_inputs: {
                            valid: "border-blue-600",
                            no_valid: "border-red-600",
                            default: "w-full py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none ",
                            submit: "bg-black text-white"
                        },
                        div_container_error: {
                            container: "my-2",
                            text_error: "text-red-600",
                        },
                        div_container: "grid grid-cols-1 sm:grid-cols-3 sm:gap-10",
                    }
                }
            },
            validations: {
                type: Object,
                required: true,
                default () {
                    return {
                        names: {
                            required: helpers.withMessage('El campo es requerido', requiredIf(true))
                        },
                        paternal_name: {
                            required: helpers.withMessage('El campo es requerido', requiredIf(true))
                        },
                        maternal_name: {
                            required: helpers.withMessage('El campo es requerido', requiredIf(true))
                        },
                        birthdate: {
                            required: helpers.withMessage('El campo es requerido', requiredIf(true))
                        },
                        percentage: {
                            required: helpers.withMessage('El campo es requerido', requiredIf(true))
                        },
                        relationship: {
                            required: helpers.withMessage('El campo es requerido', requiredIf(true))
                        }
                    };
                }
            }
        },
        setup(props) {
    
            let isLoading = ref(false);
            let base = {
                names: "",
                paternal_name: "",
                maternal_name: "",
                birthdate: "",
                percentage: 0,
                relationship: ""
            }
            let beneficiariesModel = ref(JSON.parse(JSON.stringify(base)));
    
            beneficiariesModel.value;
            let beneficiariesList = ref([]);
    
            const beneficiariesModelValidations = useVuelidate(props.validations, beneficiariesModel);
    
            function addBeneficiary(){
                beneficiariesModelValidations.value.$touch();
                if(beneficiariesModelValidations.value.$error) return;
    
                let isPossibleToAdd = isPossibleToAddPercentage();
                if (!isPossibleToAdd.status) {
                    
                    swal.fire({ 
                        title: 'Aviso',
                        text: 'El límite de porcentaje máximo ha sido alcanzado',
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    });
                    return;
                    
                }

                if(!validPercentage(beneficiariesModel.value.percentage)) {
                    swal.fire({ 
                        title: 'Aviso',
                        text: 'Porcentaje inválido, agregue un porcentaje mayor a 0% y menor o igual a 100%',
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    });
                    return;
                };
    
                beneficiariesModel.value.percentage = parseInt(beneficiariesModel.value.percentage);
                beneficiariesList.value.push(beneficiariesModel.value);
                beneficiariesModel.value = JSON.parse(JSON.stringify(base));
                beneficiariesModelValidations.value.$reset()        
            }
    
            function removeBeneficiary(index){
                beneficiariesList.value.splice(index, 1);
            }
    
            
            function validPercentage(value){
                let total = getPercentage();
                total = value + total;
                return total > 0 && total < 101;
            }
    
            function isPossibleToAddPercentage(){
                let total = getPercentage();
                return { status: total < 100, percentage: total};
            }
            
            function getPercentage(){
                return beneficiariesList.value.reduce((total, object) => {
                    return total + object.percentage;
                }, 0);
            }
            
            function getAgeByBirthDate(birthdate) {
                
                // Separacion de año, mes y dia
                let date = birthdate.toString().split('/').reverse();
                
                // Reorganacion de año, mes y dia
                birthdate = `${date[0]}-${date[1]}-${date[2]}`;
                
                // Fecha de nacimiento
                var fechaNacimiento = new Date(birthdate);

                // Fecha actual
                var fechaActual = new Date();

                // Cálculo de la edad
                var edad = fechaActual.getFullYear() - fechaNacimiento.getFullYear();
                
                // Ajuste por mes y día de nacimiento
                var m = fechaActual.getMonth() - fechaNacimiento.getMonth();
                if (m < 0 || (m === 0 && fechaActual.getDate() < fechaNacimiento.getDate())) {
                    edad--;
                }
                
                return edad;
            }
            
            function execute_validation() {
                let percentage = getPercentage();
                if (percentage != 100) return null;
                return beneficiariesList.value;
            }

            return {
                isLoading,
                beneficiariesModel,
                beneficiariesModelValidations,
                beneficiariesList,
                addBeneficiary,
                removeBeneficiary,
                execute_validation,
                getAgeByBirthDate
            }
        },
        components: {
            LoadingVue
        }
    }
</script>